import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FormSelectOption } from '../../../../form-controls/entities/form-select-option.entity';
import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { FormDualListI18n } from '../entities/form-dual-list-i18n';
import { AsyncPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ShFormDualListBaseComponent } from '../base/form-dual-list-base.component';
import { ShFormGroupComponent } from '../../_core/form-group/form-group.component';

@Component({
    selector: 'sh-form-dual-list',
    templateUrl: './form-dual-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ShFormGroupComponent, ShFormDualListBaseComponent, ReactiveFormsModule, AsyncPipe]
})
export class ShFormDualListComponent extends ShBaseFormComponent {
    @Input() allOptions!: FormSelectOption[];
    @Input() initialSelectedOptions: FormSelectOption[] = [];
    @Input() i18n!: FormDualListI18n;
    @Input() leftHeaderText?: string;
    @Input() rightHeaderText?: string;
    @Input() leftHasError?: boolean = false;
    @Input() rightHasError?: boolean = false;
    @Input() disabledInfoMsg?: string = '';
}
